import medMutationHooks from './medMutationHooks.ts';
import recallMutationHooks from './recallMutationHooks.ts';
import outboundDocumentMutationHooks from './outboundDocumentMutationHooks.ts';
import userMutationHooks from './userMutationHooks.ts';
import tradingPartnerMutationHooks from './tradingPartner.ts';
import customerLocationMutationHooks from './customerLocation.ts';
import settingsMutationHooks from './settingsMutationHooks.ts';
import quarantineMutationHooks from './quarantineMutationHooks.ts';

const hooks = {
  customerLocations: customerLocationMutationHooks,
  quarantine: quarantineMutationHooks,
  med: medMutationHooks,
  outboundDocument: outboundDocumentMutationHooks,
  recall: recallMutationHooks,
  settings: settingsMutationHooks,
  tradingPartner: tradingPartnerMutationHooks,
  user: userMutationHooks,
};

export default hooks;
